import { Injectable } from '@angular/core';
import { StorageService } from './storage.service';
import { CustomerService } from './customer.service';
import { ApiService } from './api.service';

import { Customer, OnlineOrder } from '../models';

import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OnlineOrdersService {
	customer: Customer;

	online_orders: OnlineOrder[];
	pending_online_orders: OnlineOrder[];
  active_online_orders: OnlineOrder[];

  active_statuses: string[] = ['pending', 'confirmed', 'producing', 'produced', 'in_transit'];

	n_items: number;
  n_pending_items: number;
  n_active_items: number;

	selectedOnlineOrder: OnlineOrder;

  constructor(private api: ApiService,
  	private storage: StorageService,
  	private customerServ: CustomerService) {

  }

  clearSelected() {
  	this.storage.removeInSession('selected_online_order');
  }
  setSelected(oo: OnlineOrder) {
  	this.storage.storeInSession('selected_online_order', oo);
  }
  getSelected() {
  	return this.storage.getInSession('selected_online_order');
  }

  fetch(): Observable<any> {
  	this.customer = this.customerServ.getCustomer();
  	
  	return new Observable<any>((obs) => {
  		if(!this.customer.token) {
  			obs.next({online_orders: [], total: 0});
  			obs.complete();
  			return;
  		}

	  	this.api.index('online_orders', {
	  		token: this.customer.token,
	  		o: {
	  			id: 'desc'
	  		}
	  	}).subscribe(
	  		res => {
	  			for(let oo of res.online_orders) {
	  				OnlineOrder.setAdditionalData(oo);
	  			}
	  			
	  			this.online_orders = res.online_orders;
	  			this.n_items = res.total;
	  			this._getActive();
	  			obs.next(res);
	  		},
	  		err => {
	  			obs.error(err);
	  			console.log(err);
	  		},
	  		() => {
	  			obs.complete();
	  		}
	  	);
  	})
  }

  private _getActive() {
  	this.pending_online_orders = [];
    this.active_online_orders = [];
    
  	for(let oo of this.online_orders) {
  		if(oo.status == "pending"){
  			this.pending_online_orders.unshift(oo);
        this.active_online_orders.unshift(oo);
      } else if(this.active_statuses.indexOf(oo.status) > -1) {
        this.active_online_orders.unshift(oo);
      }
  	}
  	this.n_pending_items = this.pending_online_orders.length;
    this.n_active_items = this.active_online_orders.length;
  }
}
